import { Box, Stack, styled } from "@mui/material";
import { Text } from "../../../core-ui/components/Text/Text";

export const UploadReleaseTrackLoadingContainer = styled(Stack)(
  ({ theme }) => ({
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    borderRadius: theme.border.radius.md,
    border: `dashed 1px ${theme.palette.divider}`,
    backgroundColor: theme.palette.customColor.monochromeBackgroundColor,
  }),
);

export const UploadReleaseTrackSongTitle = styled(Text)(({ theme }) => ({
  maxWidth: "100px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "150px",
  },
}));

export const UploadReleaseTrackPlayerContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 2, 3, 2),
  display: "flex",
  flexDirection: "column",
  flex: 1,
  gap: theme.spacing(3),
  height: "100%",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.border.radius.md,
}));
